import { Box, BoxProps, Container } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SeriesCarousel } from '@/components/ui/features/library/OriginalsSection/components/SeriesCarousel';
import { NoResults } from '@/components/ui/shared/messages/NoResults/NoResults';
import { GroupPanel } from '@/components/ui/shared/panels/GroupPanel/GroupPanel';
import { useResources } from '@/lib/datx-jsonapi-react';
import { queryAllOriginalsSeries } from '@/queries/originals-series';

export const OriginalsSection: FC<BoxProps> = ({ ...rest }) => {
  const { t } = useTranslation();
  const { data } = useResources(queryAllOriginalsSeries({ collection: 'false' }));

  if (data && data.length === 0) {
    return null;
  }

  return (
    <Box w="full">
      <Container px={{ base: 5, md: 10, lg: 5 }} {...rest}>
        <GroupPanel heading={t('library.originals.headline')}></GroupPanel>
      </Container>

      <Box my="32px">
        {!data?.length && <NoResults title={t('common.noResults')} />}
        {data?.length && <SeriesCarousel series={data} />}
      </Box>
    </Box>
  );
};
